__webpack_require__.p = "/activity/myCity/";